module.exports = __webpack_public_path__ + "media/images/principal-f784606ec22992123ad435fbb54bd32e.jpg";